import React, { useEffect, useRef } from 'react'
import styles from './AmenitiesSection.module.css'

// Replace with actual imports:
import lobbyImg from '../../assets/lobby.jpg'
import elevatorImg from '../../assets/elevator.jpg'
import livingImg from '../../assets/living.jpg'

const features = [
    {
        title: 'The Lobby',
        description: 'A double-height, air-conditioned lobby leads you towards two majestic towers. Designed with premium materials and clean detailing, it creates a strong first impression without trying too hard.',
        image: lobbyImg,
        imageLeft: false,
    },
    {
        title: 'Private By Design',
        description: 'Each residence is served by two private elevators that open directly into a private foyer. No shared corridors. No interaction with other residents, unless you choose it. Just a clean, private arrival into your home. A separate service elevator ensures staff movement remains completely independent.',
        image: elevatorImg,
        imageLeft: true,
    },
    {
        title: 'Double-Height Living',
        description: "Select 5-bedroom residences feature double-height living spaces. This isn't just visual drama — it creates a real sense of volume, light and openness that you feel every day.",
        image: livingImg,
        imageLeft: false,
    },
]
const AmenitiesSection = () => {
    const rowRefs = useRef([])

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(styles.visible)
                    }
                })
            },
            { threshold: 0.15 }
        )

        rowRefs.current.forEach((el) => el && observer.observe(el))
        return () => observer.disconnect()
    }, [])

    return (
        <section className={styles.section}>
            {features.map((feature, i) => (
                <div
                    key={i}
                    ref={(el) => (rowRefs.current[i] = el)}
                    className={`${styles.row} ${feature.imageLeft ? styles.rowLeft : styles.rowRight}`}
                >
                    {/* Image */}
                    <div className={styles.imgWrapper}>
                        <img
                            src={feature.image}
                            alt={feature.title}
                            className={styles.img}
                        />
                        <div className={styles.imgOverlay}></div>
                        <span className={styles.caption}>Artist's Impression</span>
                    </div>

                    {/* Text */}
                    <div className={styles.text}>
                        <div className={styles.goldLine}></div>
                        <h2 className={styles.title}>{feature.title}</h2>
                        <p className={styles.desc}>{feature.description}</p>
                    </div>
                </div>
            ))}
        </section>
    )
}

export default AmenitiesSection